import { PRO_ROLES, Role, RoleArray, USER_ROLES } from "access/definitions";
import { roleAtom } from "@auth/firebase/state";
import { useAtom } from "jotai";

function getRoleColor(role: Role) {
    if (USER_ROLES.includes(role)) {
        return 'bg-green-300'
    } else if (PRO_ROLES.includes(role)) {
        return 'bg-blue-300'
    } else {
        return 'bg-gray-300'
    }
    return ''
}

export function ChangeRole() {
    const [roleData, setRoleData] = useAtom(roleAtom);

    return (
        <div className="fixed bottom-5 right-0 z-50">
            <div className="dropdown dropdown-top dropdown-end">
                <div tabIndex={0} role="button" className="btn btn-ghost btn-sm btn-circle m-1">
                    <span className={`w-4 h-4 rounded-full ${getRoleColor(roleData.role)}`}></span>
                </div>
                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow mb-2">
                    {RoleArray.map((_role) => (
                        <li key={_role}>
                            <a className={`${_role == roleData.role ? 'bg-primary' : ''}`} onClick={() => setRoleData({ ...roleData, role: _role })}>
                                <span className={`w-2 h-2 rounded-full ${getRoleColor(_role)}`}></span>{_role}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
